import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const BasicNewsletterTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect width="71.1111" height="80" rx="4" fill={getColor(color, isColorInherited)} />
    <rect
      x="7.86108"
      y="6.97217"
      width="26.0556"
      height="21.6111"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <rect
      x="7.86108"
      y="36.3057"
      width="17.1667"
      height="15.3889"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <rect
      x="7.86108"
      y="57.6389"
      width="17.1667"
      height="15.3889"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <line
      x1="41"
      y1="7"
      x2="64.7778"
      y2="7"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="41"
      y1="14.1111"
      x2="64.7778"
      y2="14.1111"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="41"
      y1="21.2222"
      x2="64.7778"
      y2="21.2222"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="41"
      y1="28.3333"
      x2="64.7778"
      y2="28.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="37.2222"
      x2="64.7777"
      y2="37.2222"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="44.3333"
      x2="64.7777"
      y2="44.3332"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="51.4443"
      x2="64.7777"
      y2="51.4443"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="58.5557"
      x2="64.7777"
      y2="58.5557"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="65.6667"
      x2="64.7777"
      y2="65.6667"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="31.2222"
      y1="72.7778"
      x2="64.7777"
      y2="72.7778"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
